import { makeStyles } from "@material-ui/core/styles";
import {
  DarkGrey,
  LightPrimaryColor,
  PrimaryColor,
  White,
} from "../../shared/styles/colors";

export default makeStyles(() => ({
  sidebar: {
    display: "flex",
    position: "fixed",
    flexDirection: "column",
    width: "250px",
    height: "100vh",
    top: 0,
    left: -10,
    textAlign: "left",
    padding: "5px",
    border: "none",
    background: "rgba(214, 214, 214, .3)",
  },
  topDiv: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
  },
  fullLogo: {
    width: "150px",
    marginTop: "50px",
    marginLeft: "20px",
  },
  logo: {
    width: "60px",
    marginTop: "50px",
    marginLeft: "0px",
  },
  icon: {
    margin: "2%",
    "& path": {
      fill: White,
    },
  },
  menu: {
    marginTop: "20%",
    marginRight: "2%",
  },
  selectedMenu: {
    background: PrimaryColor,
    color: White,
    borderRadius: "5px",
    padding: "5px 5px 5px 15px",
    textAlign: "start",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  selectedText: {
    color: White,
    "&:hover": {
      color: "#777",
    },
  },
  text: {
    color: DarkGrey,
    fontWeight: 700,
  },
  versionDiv: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    bottom: "0px",
    left: "0px",
    width: "100%",
    height: "50px",
    color: LightPrimaryColor,
  },
  versionText: {
    fontSize: "12px",
    color: LightPrimaryColor,
  },
}));
